module.exports = "/_next/static/images/app-fc85d4cc6ac10151a5daf0afedec4956.svg";